import React, { useState } from "react";
import { string, bool } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { AirlineHP } from "../Card";
import { RCL } from "../RCL";
import testData from "./TipsTestData";
import * as styles from "./Tips.module.scss";

const cx = classNames.bind(styles);

const close = <RCL searchKey="close" />;
const exploreMore = <RCL searchKey="explore-more" />;

const Tips = ({ title, displayArticles, articlesSectionTitle }) => {
	const [articlesHidden, toggleArticles] = useState(false);

	const tipsList = testData.tips;
	const articlesList = testData.articles;

	let stateClasses = "";
	let stateClassesInverse = cx("isHidden");
	let articleStateClasses = "";

	if (articlesHidden === false) {
		stateClasses = "";
		stateClassesInverse = cx("isHidden");
		articleStateClasses = "";
	} else {
		stateClasses = cx("isHidden");
		stateClassesInverse = "";
		articleStateClasses = cx("articlesHidden");
	}
	return (
		<div className={cx("container")}>
			<div className={cx("tipsContainer")}>
				<div className={cx("tipsNav")}>
					{title && (
						<div className={cx("tipsNavHeading")}>
							<span className={cx("tipsNavHeadingText")}>{title}</span>
						</div>
					)}
					{tipsList && (
						<ul className={cx("tipsNavList", "listClean")}>
							{tipsList.map(entry => (
								<li key={entry.contentful_id} className={cx("tip")}>
									{entry.tipHeading && <span className={cx("tipNumber")}>{entry.tipHeading}</span>}
									{entry.text && <p>{entry.text}</p>}
								</li>
							))}
						</ul>
					)}
				</div>

				{displayArticles && (
					<div className={cx("tipsBody", articleStateClasses)}>
						{articlesSectionTitle && (
							<div className={cx("tipsBodyHeadingText")}>{articlesSectionTitle}</div>
						)}
						{articlesList && (
							<ul className={cx("tipsArticlesList", "listClean")}>
								{articlesList.map(article => (
									<li key={article.contentful_id} className={cx("article")}>
										<AirlineHP
											data={{
												to: article.url,
												image: {
													alt: article.title,
													source: {
														src: article.image,
													},
												},
												footer: article.title,
											}}
										/>
									</li>
								))}
							</ul>
						)}
					</div>
				)}
			</div>
			{displayArticles && (
				<div className={cx("toggleButtonContainer")}>
					<button
						type="button"
						className={cx("toggleButton", "buttonClean")}
						onClick={() => toggleArticles(!articlesHidden)}>
						<span className={cx(stateClasses)}>
							<span>{close}</span>
							<i className="fas fa-chevron-up" />
						</span>
						<span className={cx(stateClassesInverse)}>
							<span>{exploreMore}</span>
							<i className="fas fa-chevron-down" />
						</span>
					</button>
				</div>
			)}
		</div>
	);
};

Tips.propTypes = {
	title: string.isRequired,
	displayArticles: bool,
	articlesSectionTitle: string,
};

Tips.defaultProps = {
	displayArticles: null,
	articlesSectionTitle: null,
};

export default Tips;
export { Tips };
